import { ExecuteEndpoint } from '../../components/common/BaseApiService';
import { DEFAULT_UPLOAD_TIMEOUT } from '../../config/consts';
import { TranslationsResponse } from '../../Model/responseDtos/TranslationsResponse';
import { ValidateTranslationCsvResponse } from '../../Model/responseDtos/ValidateTranslationCsvResponse';

export const buildTranslationCsvEndpointPath = (locale: string) => `translations/${locale}/csv`;

export class TranslationsService {
  public async getTranslations(locale: string): Promise<TranslationsResponse> {
    return ExecuteEndpoint(`translations/${locale}`, 'GET');
  }

  public async uploadTranslations(locale: string, file: File): Promise<boolean> {
    const formData = new FormData();

    if (file) {
      formData.append('csv', file);
    }

    return ExecuteEndpoint(`translations/${locale}`, 'POST', { body: formData }, DEFAULT_UPLOAD_TIMEOUT);
  }

  public async validateTranslationCsvFile(locale: string, file: File): Promise<ValidateTranslationCsvResponse> {
    const formData = new FormData();

    if (file) {
      formData.append('csv', file);
    }

    return ExecuteEndpoint(`translations/${locale}/csv/validate`, 'POST', { body: formData }, DEFAULT_UPLOAD_TIMEOUT);
  }
}
